import { AudioMessage, Message, MessageType } from "@/store/chats/types";

export const getIsMessageAudioType = (
  message: Message,
): message is AudioMessage => {
  return message.type === MessageType.Audio;
};
